import { ExternalCalendar, ID } from '@griply/types';

import { coerceCalendars } from '../converters/external-connection-calendars';
import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionCalendarsPayload = {
  externalConnectionId: ID;
};

export type GetExternalConnectionCalendarsOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionCalendarsPayload;
};

export const getExternalConnectionCalendars = async <TFunctions>(
  options: GetExternalConnectionCalendarsOptions<TFunctions>,
): Promise<ExternalCalendar[]> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    GetExternalConnectionCalendarsPayload,
    ExternalCalendar[]
  >(functions, 'externalConnections-getCalendars');

  const { data } = await callable(payload);

  // the wire type is a cast, not a validation — a malformed entry must degrade, not crash the picker
  return coerceCalendars(data);
};
